import { render, staticRenderFns } from "./TrusteeOrganization.vue?vue&type=template&id=795b491c&"
import script from "./TrusteeOrganization.vue?vue&type=script&lang=js&"
export * from "./TrusteeOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports